import React from "react";

import { Alert, MarkdownLite, Text } from "@origin-digital/ods-core";

import {
  ERGON_AVAILABILITY_DUAL,
  ERGON_AVAILABILITY_ELEC,
} from "@origin-digital/sales-common-types-fns";

interface ErgonPatchAlertProps {
  emptyPlans: boolean;
  isErgon: boolean;
  isErgonSolar: boolean;
  selectedFuel: { electricity: boolean; gas: boolean };
}

export const ErgonPatchAlert: React.FC<ErgonPatchAlertProps> = ({
  emptyPlans,
  isErgon,
  isErgonSolar,
  selectedFuel,
}) => {
  if (!isErgon) return null;

  if (emptyPlans) {
    return renderAlert(ERGON_AVAILABILITY_ELEC);
  }

  if (!isErgonSolar) return null;

  if (selectedFuel.gas && !selectedFuel.electricity) return null;

  const content =
    selectedFuel.gas && selectedFuel.electricity
      ? ERGON_AVAILABILITY_DUAL
      : ERGON_AVAILABILITY_ELEC;

  return renderAlert(content);
};

const renderAlert = ({ heading, body }: { heading: string; body: string }) => (
  <Alert tone="critical" title={heading}>
    <Text>
      <MarkdownLite>{body}</MarkdownLite>
    </Text>
  </Alert>
);
